// extracted by mini-css-extract-plugin
module.exports = {"table":"style_table__1Wg58","row":"style_row__hV3Zj","header":"style_header__2gYq4"};